import {
  AccountSyncState,
  ClientContributionOwner,
  ClientState,
  ConnectionStatusKind,
  ContributionKind,
  ContributionLimitKind,
} from "wealthmode-frontend/backend"

export const CLIENT_STATE_LABELS: Record<ClientState, string> = {
  pending: "Pending",
  active: "Active",
  disabled: "Disabled",
}

export const CLIENT_STATE_COLORS: Record<ClientState, string> = {
  pending: "text-status-warn",
  active: "text-foreground-secondary",
  disabled: "text-information-negative",
}

export const CONNECTION_STATUS_LABELS: Record<ConnectionStatusKind, string> = {
  error: "Error",
  warning: "Warning",
  updating: "Updating",
  ok: "OK",
}

export const CONNECTION_STATUS_COLORS: Record<ConnectionStatusKind, string> = {
  error: "text-information-negative",
  warning: "text-status-warn",
  updating: "text-information-neutral",
  ok: "text-information-positive",
}

export const SYNC_STATE_LABELS: Record<AccountSyncState, string> = {
  new: "New",
  failed: "Failed",
  stale: "Stale",
  synced: "Synced",
}

export const SYNC_STATE_COLORS: Record<AccountSyncState, string> = {
  new: "text-information-neutral",
  failed: "text-information-negative",
  stale: "text-status-warn",
  synced: "text-information-positive",
}

/**
 * Subpages hanging off an account's data. `label` is the abbreviation the
 * account list row uses, `title` the full name the account page and the
 * breadcrumbs use.
 */
export const ACCOUNT_DATA_LINKS = [
  { rel: "investment_holdings", label: "Holdings", title: "Investment Holdings" },
  { rel: "investment_transactions", label: "Txns", title: "Investment Transactions" },
  { rel: "recurring_investment_transactions", label: "Rec Txns", title: "Recurring Investment Transactions" },
  { rel: "depository_transactions", label: "Txns", title: "Depository Transactions" },
  { rel: "recurring_depository_transactions", label: "Rec Txns", title: "Recurring Depository Transactions" },
  { rel: "dividends", label: "Dividends", title: "Dividends" },
  { rel: "estimated_account_values", label: "Values", title: "Estimated Account Values" },
  { rel: "contributions", label: "Ctbs", title: "Contributions" },
  { rel: "recurring_contributions", label: "Rec Ctbs", title: "Recurring Contributions" },
] as const

/** Whose limits a client-level contribution counts against. */
export const CLIENT_CONTRIBUTION_OWNER_LABELS: Record<ClientContributionOwner, string> = {
  client: "Client",
  spouse: "Spouse",
  household: "Household",
}

/** Who funded a contribution, in the order a year's amounts are shown. */
export const CONTRIBUTION_KIND_LABELS: { kind: ContributionKind; title: string }[] = [
  { kind: "employee", title: "Employee" },
  { kind: "employer", title: "Employer" },
  { kind: "unknown", title: "Unknown" },
]

export const CONTRIBUTION_LIMIT_KIND_LABELS: Record<ContributionLimitKind, string> = {
  "401k_deferral": "401(k) Deferral",
  "401k_total": "401(k) Total",
  ira: "IRA",
  hsa_self: "HSA (Self)",
  hsa_family: "HSA (Family)",
}

/** A limit's kind, or the kind as the api named it where it is not one this knows. */
export function contributionLimitKindLabel(kind: string): string {
  return CONTRIBUTION_LIMIT_KIND_LABELS[kind as ContributionLimitKind] ?? kind
}
